import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react'
import { createRoot } from 'react-dom/client'
import 'navigator.sendbeacon'

import { Tracking, TrackingProvider } from 'ak-react-utils'
import packageJson from '../package.json'
import OrganisationComponent from './OrganisationComponent'
import CatalogOrderComponent from 'catalog_order_component'

const { version: APP_VERSION, name: APP_NAME } = packageJson

navigator.sendBeacon(
  'https://api.apps.austauschkompass.de/' + APP_NAME + '/track',
  JSON.stringify({ version: APP_VERSION, url: document.location.href })
)

const DEFAULT_SCHUELERAUSTAUSCH_CONFIG = {
  upsell: true,
  upsellPrechecked: false,
  userFilter: false,
  orderApiUrl: 'https://api.orders.austauschkompass.de',
  crmApiUrl: 'https://api.crm.austauschkompass.de',
  ratingApiUrl: 'https://www.schueleraustausch.de',
  filter_catalogEnabledOnly: true,
}

const DEFAULT_SPRACHREISEN_CONFIG = {
  upsell: true,
  upsellPrechecked: false,
  userFilter: true,
  orderApiUrl: 'https://api.orders.austauschkompass.de',
  crmApiUrl: 'https://api.crm.austauschkompass.de',
  ratingApiUrl: 'https://ratings.austauschkompass.de',
  filter_catalogEnabledOnly: true,
  //filter_targetGroup: 'seniors',
  //filter_countryCode: 'MT',
}

const FILTER_KEY_REGEX = /^filter_/
const rootEle = document.getElementById('ak-organisation-app')
const rawAkConfig = rootEle.dataset.akConfig
let akConfig = JSON.parse(rawAkConfig)

if (!(akConfig.businessArea.length > 5) ||
  akConfig.businessArea === "%REACT_APP_BUSINESS_AREA%"||
  !(akConfig.crmApiToken.length > 5) ||
  akConfig.crmApiToken === "%REACT_APP_CRM_API_TOKEN%"||
  !(akConfig.orderApiToken.length > 5) ||
  akConfig.orderApiToken === "%REACT_APP_ORDER_API_TOKEN%") {
  console.error("Missing necessary config: businessArea, crmApiToken or orderApiToken")
}

const DEFAULT_CONFIG = akConfig.businessArea === 'schueleraustausch' ? DEFAULT_SCHUELERAUSTAUSCH_CONFIG : DEFAULT_SPRACHREISEN_CONFIG
let filterConfig = {}

Object.keys(DEFAULT_CONFIG).forEach((key) => {
  /* NOTE: We treat `""` (empty string), `null` and `undefined` in
     `akConfig` the same and override it with the defaults in
     DEFAULT_CONFIG. Using `Object.assign({}, DEFAULT_CONFIG,
     akConfig)` instead would not!
   */
  if (!(key in akConfig)) {
    akConfig[key] = DEFAULT_CONFIG[key]
  }
})

Object.keys(akConfig).forEach((key) => {
  if (key.match(FILTER_KEY_REGEX)) {
    const nestedKeyName = key.replace(FILTER_KEY_REGEX, '')
    filterConfig[nestedKeyName] = akConfig[key]
    delete akConfig[key]
  }
})

// Use global tracking ids by default
let mtId = window.AK_TRACKING_MT_ID
let gaId = window.AK_TRACKING_GA_ID

// but allow explicitly set ones to override them
if (akConfig.gaId) {
  gaId = akConfig.gaId
}

if (akConfig.mtId) {
  mtId = akConfig.mtId
}

const tracker = new Tracking({
  enabled: !!(mtId || gaId),
  gaId,
  mtId,
  mtUrl: 'https://stats.schueleraustausch.net',
  debug: false
})

Object.assign(akConfig, {
  referrer: document.location.href,
  filter: filterConfig
})

const root = createRoot(rootEle)

root.render(
  <TrackingProvider tracker={tracker}>
    <OrganisationComponent {...akConfig}>
      {({ selectedOrganisation, countryCode, onFinish }) => (
        <CatalogOrderComponent
          apiUrl={akConfig.orderApiUrl}
          apiToken={akConfig.orderApiToken}
          crmApiUrl={akConfig.crmApiUrl}
          crmApiToken={akConfig.crmApiToken}
          businessArea={akConfig.businessArea}
          upsell={akConfig.upsell}
          upsellPrechecked={akConfig.upsellPrechecked}
          organisationId={selectedOrganisation.slug}
          interestInSchoolPrograms={akConfig.businessArea === 'schueleraustausch'
                                  ? selectedOrganisation
                                    .additional_config
                                    .school_programs_upsell_only
                                  : false}
          exchangeCountryCode={countryCode}
          onFinish={onFinish}
        />
      )}
    </OrganisationComponent>
  </TrackingProvider>
)
